module.exports = __webpack_public_path__ + "static/img/home03.f6b7287f.png";